import { StockItem, NameGroup, DimensionGroup } from '../types';

/**
 * Groups stock items by name, then by dimensions.
 * Produces a 3-level hierarchy: Name → Dimensions → Individual items.
 */
export function groupItemsByNameAndDimensions(items: StockItem[]): NameGroup[] {
  const nameMap = new Map<string, StockItem[]>();

  for (const item of items) {
    const key = item.name;
    if (!nameMap.has(key)) nameMap.set(key, []);
    nameMap.get(key)!.push(item);
  }

  const result: NameGroup[] = [];

  for (const [name, nameItems] of nameMap) {
    const dimMap = new Map<string, StockItem[]>();

    for (const item of nameItems) {
      const dimKey = formatDimensionKey(item);
      if (!dimMap.has(dimKey)) dimMap.set(dimKey, []);
      dimMap.get(dimKey)!.push(item);
    }

    const dimensionGroups: DimensionGroup[] = [];
    for (const [dimKey, dimItems] of dimMap) {
      dimensionGroups.push({
        dimensionKey: dimKey,
        width: dimItems[0].width,
        height: dimItems[0].height,
        thickness: dimItems[0].thickness,
        totalQuantity: dimItems.reduce((sum, i) => sum + i.quantity, 0),
        itemCount: dimItems.length,
        items: dimItems,
      });
    }

    result.push({
      name,
      totalQuantity: nameItems.reduce((sum, i) => sum + i.quantity, 0),
      itemCount: nameItems.length,
      dimensionGroups,
    });
  }

  return result;
}

function formatDimensionKey(item: StockItem): string {
  if (!item.width && !item.height) return 'sem dimensão';
  const parts: number[] = [];
  if (item.width) parts.push(item.width);
  if (item.height) parts.push(item.height);
  if (item.thickness) parts.push(item.thickness);
  return parts.join(' x ') + ' mm';
}
